import type { MetaFunction } from "@remix-run/node";
import { getSeoMeta } from "~/utils/seo-meta";
import { SEOLayout } from "~/components/seo/SEOLayout";
import { SolutionSeoPage } from "~/components/seo/SolutionSeoPage";
import { SOLUTION_SEO_CONFIG } from "~/utils/seo-solution-content";

export const meta: MetaFunction = () => {
  const content = SOLUTION_SEO_CONFIG["gamified-checkout"];
  return getSeoMeta({
    title: content.title,
    description: content.description,
    url: "/solutions/gamified-checkout",
  });
};

export default function SolutionGamifiedCheckout() {
  return (
    <SEOLayout>
      <SolutionSeoPage content={SOLUTION_SEO_CONFIG["gamified-checkout"]} />
    </SEOLayout>
  );
}
